module.exports = __webpack_public_path__ + "static/img/jumping_jack.59ca62d3.png";